// extracted by mini-css-extract-plugin
module.exports = {"carouselContainer":"PrizeRecommendationSection_carouselContainer__qTxWJ"};